import React from 'react';

export const MOBTexts = {
  title: {
      ko: (
        <>
          통신사 전문 보안 솔루션
        </>
      ),
      en: (
        <>
          Telecom Security Solution
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          Mobileum
        </>
      ),
      en: (
        <>
          Mobileum
        </>
      )
  }
};

export const functionTexts = {
  title: {
      ko: (
        <>
          Mobileum 제품
        </>
      ),
      en: (
        <>
          Mobileum Products
        </>
      )
  },
  roaming:
    {
      title: {
        ko: '글로벌 로밍 환경을 실시간으로 제어하고 수익성과 품질을 동시에 최적화하는 로밍 인텔리전스 솔루션',
        en: 'Optimize roaming profitability and quality simultaneously with real-time control of the global roaming environment'
      },
      desc: {
        ko: <>
          국가·사업자·네트워크에 관계없이
          로밍 트래픽과 품질을 실시간으로 분석하여
          최적의 네트워크 선택과 비용 절감을 자동으로 수행
        </>,
        en: <>
          Countries, operators, and networks analyzed in real-time
          Roaming traffic and quality analyzed in real-time
          Automatically performs optimal network selection and cost reduction
        </>
      }
    },
  risk: 
    {
      title: {
        ko: '통신 사기와 위협을 발생 이전 단계에서 탐지·차단하는 지능형 리스크 관리 솔루션',
        en: 'Intelligent risk management solution that detects and blocks telecom fraud and threats before they occur'
      },
      desc: {
        ko: <>
          SIM Fraud, IRSF, 시그널 공격 등
          고도화된 통신 위협을 실시간으로 분석하여
          통신사의 수익 손실과 보안 리스크를 원천적으로 방지
        </>,
        en: <>
          SIM Fraud, IRSF, signaling attacks, and more
          Analyze advanced telecom threats in real-time
          Fundamentally prevent telecom revenue loss and security risks.
        </>
      }
    },
  network: 
    {
      title: {
        ko: '통신 네트워크 전 구간을 보호하는 실시간 시그널 기반 보안 솔루션',
        en: 'Real-time signaling-based security solution that protects the entire telecom network'
      },
      desc: {
        ko: <>
          SS7, Diameter, 5G 시그널을 포함한
          네트워크 핵심 구간을 지속적으로 모니터링하여
          외부 공격과 내부 이상 행위를 즉각적으로 차단
        </>,
        en: <>
          SS7, Diameter, 5G signaling included
          Continuously monitor key network segments
          Immediately block external attacks and internal anomalies
        </>
      }
    },
  testing: 
    {
      title: {
        ko: '네트워크 변화와 서비스 품질을 사전에 검증하고 가시화하는 테스트·관측 솔루션',
        en: 'Test and observation solution that pre-validates and visualizes network changes and service quality'
      },
      desc: {
        ko: <>
          서비스 출시 전후의 네트워크 동작을 정밀하게 검증하고
          장애·품질 저하·설정 오류를 사전에 식별하여
          안정적인 서비스 운영 보장
        </>,
        en: <>
          Precisely verify network operations before and after service launches,
          identify failures, quality degradation, and configuration errors in advance,
          ensuring stable service operations.
        </>
      }
    },
  customer: 
    {
      title: {
        ko: '고객이 실제로 체감하는 품질을 데이터로 분석하는 고객 경험 관리 솔루션',
        en: 'Customer experience management solution that analyzes quality experienced by customers through data'
      },
      desc: {
        ko: <>
          QoS를 넘어 QoE 관점에서
          고객의 사용 패턴과 체감 품질을 분석하여
          이탈을 줄이고 만족도 극대화
        </>,
        en: <>
          Beyond QoS to QoE perspective,
          Analyze customer usage patterns and perceived quality,
          reducing churn and maximizing satisfaction
        </>
      }
    },
  data: 
    {
      title: {
        ko: '통신 데이터를 수익으로 전환하는 고도화된 데이터 분석·수익화 솔루션',
        en: 'Advanced data analytics and monetization solution that converts telecom data into revenue'
      },
      desc: {
        ko: <>
          로밍, 과금, 네트워크 데이터를 통합 분석하여
          매출 누수를 방지하고
          신규 비즈니스와 수익 창출 기회를 발굴합니다.
        </>,
        en: <>
          Roaming, billing, and network data are analyzed comprehensively
          to prevent revenue leakage
          and discover new business and revenue opportunities.
        </>
      }
    }
};

export const certTexts = {
  title: {
      ko: (<>인증</>),
      en: (<>Certifications</>)
  },
  cert:{
    iso9001:{
      ko: (<>ISO 9001:2015<br/>Quality Management System Certification</>),
      en: (<>ISO 9001:2015<br/>Quality Management System Certification</>)
    },
    isoiec27001roaming:{
      ko: (<>ISO/IEC 27001:2022<br/>Information Security Management System Certification<br/>Roaming & Core Network</>),
      en: (<>ISO/IEC 27001:2022<br/>Information Security Management System Certification<br/>Roaming & Core Network</>)
    },
    isoiec27001risk:{
      ko: (<>ISO/IEC 27001:2022<br/>Information Security Management System Certification<br/>Risk Management</>),
      en: (<>ISO/IEC 27001:2022<br/>Information Security Management System Certification<br/>Risk Management</>)
    },
    io:{
      ko: (<>IO<br/>Innovative Operators</>),
      en: (<>IO<br/>Innovative Operators</>)
    }
  }
};

export const outlineTexts = {
  title: {
      ko: (<>개요</>),
      en: (<>Outline</>)
  },
  result:{
    title:{
      ko: (<>실시간 인텔리전스. 실질적인 비즈니스 성과.</>),
      en: (<>Real-Time Intelligence. Real Business Results.</>),
    },
    container:{
      growrevenue:{
        title:{
          ko: (<>매출 증대</>),
          en: (<>Grow Revenue</>),
        },
        desc:{
          ko: (<>네트워크 데이터를 수익화하고, 고객 경험을 최적화하며, 생태계 전반에 걸쳐 새로운 수익원을 창출하세요.</>),
          en: (<>Monetize network data, optimize customer experience, and unlock new revenue streams across your ecosystem.</>),
        }
      },
      reducecost:{
        title:{
          ko: (<>비용 절감</>),
          en: (<>Reduce Cost</>),
        },
        desc:{
          ko: (<>자동화 및 데이터 기반 프로세스 최적화를 통해 운영 비용을 절감하고, 운영을 간소화하며, 회복력을 강화하십시오.</>),
          en: (<>Lower operating expenses, streamline operations, and enhance resilience through automation and data-driven process optimization.</>),
        }
      },
      mitigaterisk:{
        title:{
          ko: (<>위험 완화</>),
          en: (<>Mitigate Risk</>),
        },
        desc:{
          ko: (<>AI 기반 자동화 위험 관리를 통해 수익을 보호하고, 위험 노출을 줄이며, 규정 준수를 보장하세요.</>),
          en: (<>Protect revenue, reduce exposure, and ensure compliance through AI-powered, automated risk management.</>),
        }
      },

    }
  },
  solving:{
    title:{
      ko: (<>통신 분야에서 가장 중요한 문제 해결</>),
      en: (<>Solving What Matters Most in Telecom</>),
    },
    container:{
      roaming:{
        title:{
          ko: (<>로밍 및 상호 연결</>),
          en: (<>Roaming & Interconnection</>),
        },
        desc:{
          ko: (<>지능형 제어 및 예측 분석을 통해 트래픽과 수익성 최적화</>),
          en: (<>Optimize traffic and profitability with intelligent steering and predictive analytics.</>),
        },
        result:{
          title:{
            ko: (<>로밍 DNA</>),
            en: (<>Roaming DNA</>),
          },
          titlecomment:{
            ko: (<>로밍 인텔리전스를 실질적인 이점 전환</>),
            en: (<>Turning Roaming Intelligence into Actionable Advantage</>),
          },
          comment:{
            ko: (<>Mobileum의 Roaming DNA는 실시간 로밍 분석을 제공하여 QoE를 개선하고, SLA를 준수하며, 글로벌 네트워크 전반에서 파트너 성능을 최적화합니다.</>),
            en: (<>Mobileum’s Roaming DNA delivers real-time roaming analytics to improve QoE, enforce SLAs, and optimize partner performance across global networks.</>),
          }
        }
      },
      revenue:{
        title:{
          ko: (<>수익 보장 및 사기 관리</>),
          en: (<>Revenue Assurance & Fraud Management</>),
        },
        desc:{
          ko: (<>실시간 감지, 자동화된 품질 보증 및 위험 관리를 통해 수익 마진 보호</>),
          en: (<>Protect margins with real-time detection, automated assurance, and risk control.</>),
        },
        result:{
          title:{
            ko: (<>RAID 리스크 및 보증</>),
            en: (<>RAID Risk & Assurance</>),
          },
          titlecomment:{
            ko: (<>통신 리스크 관리를 전략적 이점으로 전환</>),
            en: (<>Turn Telecom Risk Management into a Strategic Advantage</>),
          },
          comment:{
            ko: (<>Mobileum의 AI 기반 RAID 플랫폼으로 통신 위험 관리, 보증 및 규정 준수 전략을 통합하세요. 직관적이고 배포 속도가 빠르며 측정 가능한 효과를 위해 설계된 RAID는 위험 관리를 경쟁 우위로 전환하여 성능을 향상시키고 손실을 줄이며 성장을 보장합니다.</>),
            en: (<>Unify your telecom risk, assurance, and compliance strategies with Mobileum’s AI-powered RAID platform. Intuitive, fast to deploy, and built for measurable impact, RAID transforms risk control into a competitive advantage — boosting performance, reducing losses, and safeguarding growth.</>),
          }
        }
      },
      customer:{
        title:{
          ko: (<>고객 경험 및 분석</>),
          en: (<>Customer Experience & Analytics</>),
        },
        desc:{
          ko: (<>예측 기반 고객 인텔리전스를 활용하여 끊김 없고 개인화된 경험 제공</>),
          en: (<>Deliver seamless, personalized experiences with predictive customer intelligence.</>),
        },
        result:{
          title:{
            ko: (<>DNA 인텔리전스</>),
            en: (<>DNA Intelligence</>),
          },
          titlecomment:{
            ko: (<>네트워크 데이터를 실시간 의사결정으로 전환</>),
            en: (<>Turn Network Data into Real-Time Decisions</>),
          },
          comment:{
            ko: (<>Mobileum의 DNA Intelligence는 실시간 통신 사업자급 분석 기능을 제공하여 사용자, 기기, 앱 및 QoE 전반에 걸쳐 인사이트를 도출하고 더욱 스마트한 의사 결정을 지원합니다.</>),
            en: (<>Mobileum’s DNA Intelligence delivers real-time, telco-grade analytics — powering insights across users, devices, apps, and QoE to drive smarter decisions.</>),
          }
        }

      },
      esim:{
        title:{
          ko: (<>eSIM 활성화 및 보증</>),
          en: (<>eSIM Enablement & Assurance</>),
        },
        desc:{
          ko: (<>대규모 테스트, 검증 및 사기 방지를 통해 eSIM 도입 가속화</>),
          en: (<>Accelerate eSIM adoption with testing, validation, and fraud protection at scale.</>),
        },
        result:{
          title:{
            ko: (<>eSIM 테스트</>),
            en: (<>eSIM Testing</>),
          },
          titlecomment:{
            ko: (<>원활한 eSIM 프로비저닝 및 서비스 검증</>),
            en: (<>Seamless eSIM Provisioning and Service Validation</>),
          },
          comment:{
            ko: (<>Mobileum의 eSIM 테스트는 eSIM 멀티플렉싱을 통해 모든 시나리오에서 위치에 관계없이 원활한 원격 프로비저닝 및 글로벌 검증을 보장합니다.</>),
            en: (<>Mobileum’s eSIM Testing ensures seamless remote provisioning and global validation with eSIM Multiplexing for location-independent testing across all scenarios.</>),
          }
        }

      },
      iot:{
        title:{
          ko: (<>IoT 활성화 및 위험 관리</>),
          en: (<>IoT Enablement & Risk Management</>),
        },
        desc:{
          ko: (<>엔드투엔드 가시성과 인텔리전스를 통해 IoT 생태계를 안전하게 보호하고, 안정성을 보장</>),
          en: (<>Secure, assure, and monetize IoT ecosystems with end-to-end visibility and intelligence.</>),
        },
        result:{
          title:{
            ko: (<>IoT 활성화</>),
            en: (<>IoT Enablement</>),
          },
          titlecomment:{
            ko: (<>대규모 IoT의 보안, 보장 및 수익 창출</>),
            en: (<>Secure, Assure, and Monetize IoT at Scale</>),
          },
          comment:{
            ko: (<>Mobileum은 AI 기반 위험 관리, 사용 보증, 보안 강화 및 실시간 정책 제어를 단일 인텔리전스 플랫폼에 통합하여 IoT 통합업체와 글로벌 솔루션 제공업체가 안정적으로 사업을 확장할 수 있도록 지원합니다. 당사의 솔루션은 복잡성을 단순화하고 IoT 연결을 안전하게 보호하며 대규모 수익 창출을 보장합니다.</>),
            en: (<>Mobileum empowers IoT aggregators and global solution providers to scale with confidence by delivering AI-powered risk management, usage assurance, security enforcement, and real-time policy control — all unified within a single intelligence platform. Our solution simplifies complexity, secures IoT connectivity, and ensures monetization at scale.</>),
          }
        }
      },
      security:{
        title:{
          ko: (<>보안 및 신호 보호</>),
          en: (<>Security & Signaling Protection</>),
        },
        desc:{
          ko: (<>실시간으로 위협을 감지하고 모든 프로토콜에서 네트워크 보호</>),
          en: (<>Detect threats in real time and secure your network across all protocols.</>),
        },
        result:{
          title:{
            ko: (<>Cross-Protocol Signaling 방화벽</>),
            en: (<>Cross-Protocol Signaling Firewall</>),
          },
          titlecomment:{
            ko: (<>차세대 통신 보안을 위한 통합 시그널링 방화벽</>),
            en: (<>Unified Signaling Firewall for Next-Gen Telecom Security</>),
          },
          comment:{
            ko: (<>Mobileum의 크로스 프로토콜 시그널링 방화벽으로 통신 네트워크를 보호하세요. 이 AI 기반 솔루션은 SS7, Diameter, GTP 및 HTTP/2 전반에 걸쳐 사기, 스푸핑 및 시그널링 위협으로부터 실시간으로 네트워크를 방어합니다.</>),
            en: (<>Protect telecom networks with Mobileum’s Cross-Protocol Signaling Firewall — an AI-powered solution that defends against fraud, spoofing, and signaling threats across SS7, Diameter, GTP, and HTTP/2 in real time.</>),
          }
        }
      },
    }
  },  
};